/* eslint-disable no-useless-escape */
import React, {useEffect, useState} from  'react';
import  { NavLink, withRouter } from 'react-router-dom';
import withAuthLayout from 'components/layouts/withAuthLayout';
import {ReactComponent as Logo } from 'assets/images/svg/check.svg';
import {ReactComponent as MainLogo } from  'assets/images/svg/logo.svg';

import { Formik } from 'formik';
import Swal from 'sweetalert2'


const RegisterPage = props => {

    const { history } = props;
    const listItems = [
        'Strategize with confidence',
        'Powerful collection of tools',
        'Promote your content and grow your audience on Pandora.',
        'Strategize with confidence',
        'Promote your content and grow your audience on Pandora.'
    ];

    const [allRoles, setRoles] = useState([]);

    useEffect(() => {
        fetch('https://musicandrights.herokuapp.com/api/v1/roles')
        .then(res =>  res.json())
        .then( roles => {
            setRoles(roles.data.roles);
        })
    }, []);
    return (
        <div className="row mx-0 auth-register__main">
            <div className="auth-left__container">
                <div className="auth-left">
                    
                    <div>
                        <h2 className="auth-left__header">Join Music & Right <br/>Today !</h2>
                        <p className="col-md-10 px-0 auth-left__info">Our Platform helps artists and their teams use Pandora to understand performance, grow audiences, and fuel strategy.</p>
                        <ul className="auth-left__list">
                            {
                                listItems.map( (listItem, index) => {
                                    return <li key={index} className="auth-left__list-item">
                                        <div className="circle"><Logo /></div> {listItem}</li>
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
                <div className="auth-right__container">
                    <div className="w-100 main-logo">
                        <div className="d-flex flex-row justify-content-center">
                            <MainLogo className="mx-auto"/>
                        </div>
                    </div>
                    <div className="auth-right">
                        <Formik 
                            initialValues={{full_name: '', email: '', organization: '', role_id: '', password: '', confirm_password: ''}}
                            validate={ values => {
                                let errors = {}
                                if (!values.full_name || values.full_name.length < 5) {
                                    errors.full_name = true;
                                }
                                const regexp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
                                if (!values.email ||  !regexp.test(values.email)){
                                    errors.email = true
                                }
                                if(!values.password || values.password.length < 5) {
                                    errors.password = true
                                }
                                if(!values.role_id){
                                    errors.role_id = true
                                }
                                if(!values.confirm_password || values.confirm_password.length < 5 || values.confirm_password !== values.password ) {
                                    errors.password = true
                                }
                                return errors;
                            }}
                            onSubmit={ (values, {isSubmitting, setSubmitting}) => {
                                setSubmitting(true)
                                fetch('https://musicandrights.herokuapp.com/api/v1/user/create_account',{
                                    method: 'POST',
                                    headers: {'Content-Type': 'application/json'},
                                    body: JSON.stringify(values)
                                })
                                .then(res => res.json())
                                .then(res => {
                                    setSubmitting(false)
                                    if(res.code === 201){
                                        Swal.fire({
                                            type: 'success',
                                            title: 'Account Created',
                                            text: res.data.message,
                                            onOpen: () => {
                                                setTimeout( () => {
                                                    Swal.clickConfirm()
                                                    history.push('/login')
                                                }, 2000)
                                            }
                                        }).then((confirm) => {
                                            if(confirm) {
                                                history.push('/login')
                                            }
                                        })
                                        
                                    }
                                    if (res.code === 400) {
                                        Swal.fire({
                                            type: 'error',
                                            title: 'Registration failed',
                                            text: res.message
                                        })
                                    }    
                                })
                                .catch(err => {
                                    setSubmitting(false)
                                    // console.log(err)
                                })

                            }}>
                                {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                /* and other goodies */
                                }) => (
                                    <form className="nsForm" onSubmit={handleSubmit}>
                                        <div className="auth-right__more">
                                            
                                            <h2 className="auth-login__main-header">Join Music & Right Today!</h2>
                                            <p className="auth-login__main-info">Our Platform helps artists and their teams use Pandora to understand performance, grow audiences, and fuel strategy.</p>
                                        </div>
                                        <div>
                                            <label className="nsForm-label">full name</label>
                                            <input name="full_name" className={`nsForm-input ${ touched.full_name && errors.full_name ? 'error': null}`} type="text" placeholder="Adebola James" onChange={handleChange}/>
                                        </div>
                                        <div>
                                            <label className="nsForm-label">email address</label>
                                            <input name="email" className={`nsForm-input ${ touched.email && errors.email ? 'error' : null}`} type="email" placeholder="adebolajames@gmail.com" onChange={handleChange}/>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div>
                                                    <label className="nsForm-label">organization</label>
                                                    <input name="organization" className={`nsForm-input ${ touched.organization && errors.organization ? 'error': null}`} type="text" placeholder="" onChange={handleChange}/>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div>
                                                    <label className="nsForm-label">role</label>
                                                    <div className={`nsForm-select ${ touched.role_id && errors.role_id ? 'error': null}`}>
                                                        <select name="role_id" onChange={handleChange} className={`${ touched.role_id && errors.role_id ? 'error': null}`}>
                                                            <option value="">Select Role</option>
                                                            {
                                                                allRoles && allRoles.map( (role, index) => (
                                                                    <option key={index} value={role.id}>{role.name}</option>
                                                                ))
                                                            }
                                                        </select>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="my-sm-2">
                                                    <label className="nsForm-label">create password</label>
                                                    <input name="password" className={`nsForm-input ${ touched.password && errors.password ? 'error': null}`} type="password" placeholder="" onChange={handleChange}/>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div>
                                                    <label className="nsForm-label">confirm password</label>
                                                    <input name="confirm_password" className={`nsForm-input ${ touched.confirm_password && errors.confirm_password ? 'error': null}`} type="password" placeholder="" onChange={handleChange}/>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="my-3">
                                            <p className="auth__text text--small-light text--grey">By continuing, you agree to our <NavLink to="" className="auth__link">Terms</NavLink> and <NavLink to="" className="auth__link">Privacy Policies.</NavLink></p>
                                        </div>

                                        <button type="submit" className={`pill ${isSubmitting ? 'pill--secondary': 'pill--grey'} my-2`} disabled={isSubmitting}>
                                            <p>{ isSubmitting ? 'Submitting...': 'Create Account' }</p>
                                        </button>
                                        <div className="auth__last-button pill pill--whitesmoke auth-alt-1">
                                            <p>Already have an account? <NavLink to="/login" className="auth__link">Sign in</NavLink>.</p>
                                        </div>
                                    </form>
                                
                                )}
                                

                        </Formik>
                        
                    </div>
                </div>
                <div className="auth__last-button pill pill--whitesmoke auth-alt-2">
                    <p>Already have an account? <NavLink to="/login" className="auth__link">Sign in</NavLink>.</p>
                </div>
        </div>
    )
}

export default withAuthLayout(withRouter(RegisterPage), {});

